import { render, staticRenderFns } from "./AdminVerifyAccount.vue?vue&type=template&id=dc0fd9e0&"
import script from "./AdminVerifyAccount.vue?vue&type=script&lang=js&"
export * from "./AdminVerifyAccount.vue?vue&type=script&lang=js&"
import style0 from "./AdminVerifyAccount.vue?vue&type=style&index=0&id=dc0fd9e0&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports